import { IEnv } from './env.type'

export const environment: IEnv = {
  PRODUCTION: false,
  API_PREFIX: 'https://dev.api.scienceglamping.com',
  WEBSOCKET_PREFIX: 'wss://dev.api.scienceglamping.com',
  CABINET_PREFIX: 'https://dev.my.scienceglamping.com',
}
